import { html, defineElement, TemplateElement } from '@webtides/element-js';
import style from './horizontal-scroll.css';
import hiddenScrollBarStyle from '../../../css/utilities/_hidden-scrollbar.css';
import { inVisibleScrollbarSize } from './scrollbar-size';

class HorizontalScroll extends TemplateElement {
    constructor() {
        super({ shadowRender: true, adoptGlobalStyles: false, styles: [style, hiddenScrollBarStyle] });

        const scrollBarSize = inVisibleScrollbarSize();
        if (scrollBarSize > 0) {
            this.style.setProperty('--marginBottom', `-${scrollBarSize}px`);
        }
    }

    properties() {
        return {
            selector: '',
            active: 0,
        };
    }

    watch() {
        return {
            active: () => this.scrollToActive(),
        };
    }

    get isOverflowing() {
        return this.$refs.scroll.scrollWidth > this.$refs.scroll.offsetWidth;
    }

    afterUpdate() {
        this._targets = Array.from(this.selector ? this.querySelectorAll(this.selector) : this.children);
        this._arrowTrigger = this.querySelectorAll('arrow-box-trigger');

        this.setFadeGradients();
    }
    connected() {
        this.requestUpdate().then(() => {
            this.setFadeGradients();
        });
    }

    setFadeGradients() {
        let fadeLeft = false,
            fadeRight = false;

        if (this.isOverflowing) {
            fadeLeft = this.active >= 0 && this.$refs.scroll.scrollLeft > 0;
            fadeRight =
                this.active < this._targets.length &&
                this.$refs.scroll.scrollLeft + this.$refs.scroll.offsetWidth < this.$refs.scroll.scrollWidth;
        }

        this.classList.toggle('fade-right', fadeRight);
        this.classList.toggle('fade-left', fadeLeft);
    }

    scrollToActive() {
        if (this.active < 0 || this.active > this._targets.length) {
            return;
        }
        const scrollTarget = this._targets[this.active];
        const { clientWidth, offsetLeft } = scrollTarget;

        this.$refs.scroll.scrollLeft = Math.max(
            offsetLeft + clientWidth * 0.5 - this.$refs.scroll.clientWidth * 0.5,
            0
        );

        this.setFadeGradients();
    }

    events() {
        return {
            this: {
                click: e => this.onClickTarget(e),
                transitionend: () => {
                    /**
                     * this is needed the evaluation mights think that the scrollable content is bigger than it actually is during nested tranistions
                     */
                    this.setFadeGradients();
                },
            },
            '[ref=scroll]': {
                scroll: {
                    listener: () => {
                        this._arrowTrigger.forEach(arrowTrigger => arrowTrigger.updatePosition());
                        this.setFadeGradients();
                    },
                    options: {
                        passive: true,
                    },
                },
            },
        };
    }

    onClickTarget(e) {
        const { target } = e;
        const scrollTarget = this.selector && !target.matches(this.selector) ? target.closest(this.selector) : target;
        const index = this._targets.indexOf(scrollTarget);
        if (index > -1) {
            this.active = this._targets.indexOf(scrollTarget);
        }
    }

    template() {
        // inputs value needs to be set as the last attribute otherwise it will cause a range error and display wrong initial value
        return html`
            <div class="vertical-overflow" ref="overflow">
                <div ref="scroll" class="scroll-track hidden-scrollbar">
                    <slot></slot>
                </div>
            </div>
        `;
    }
}

defineElement('horizontal-scroll', HorizontalScroll);
